import Column from '@components/column'
import Banner from './banner'
import Reviews from './reviews'
import Overview from './overview'
import Tabs from '@commons/tabs'
const ProfileInfos = () => {
  const tabs = [
    {
      title: 'Overview',
      key: 'overview',
      Component: Overview,
    },
    {
      title: 'Reviews',
      key: 'reviews',
      Component: Reviews,
    },
  ]
  return (
    <Column rowGap={20}>
      <Banner />
      <Column>
        <Tabs items={tabs} />
      </Column>
    </Column>
  )
}

export default ProfileInfos
